import React from 'react';
import { Navigate } from 'react-router-dom';

export const ProtectedRoute = ({ children, token }) => {
  if (!token) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
